import React, { createContext, useState } from "react";

export const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [token, setToken] = useState(() => localStorage.getItem("token"));
    const [roles, setRoles] = useState(() => {
        const stored = localStorage.getItem("roles");
        if (!stored) {
            const legacyRole = localStorage.getItem("role");
            return legacyRole ? [legacyRole] : [];
        }
        try {
            const parsed = JSON.parse(stored);
            return Array.isArray(parsed) ? parsed : [];
        } catch (err) {
            console.warn("Failed to parse stored roles", err);
            return [];
        }
    });
    const [userId, setUserId] = useState(() => localStorage.getItem("userId"));

    const login = (tok, assignedRoles, id) => {
        const normalizedRoles = Array.isArray(assignedRoles)
            ? assignedRoles
            : assignedRoles
                ? [assignedRoles]
                : [];
        setToken(tok);
        setRoles(normalizedRoles);
        setUserId(id ?? null);
        localStorage.setItem("token", tok);
        localStorage.setItem("roles", JSON.stringify(normalizedRoles));
        localStorage.removeItem("role");
        if (id) {
            localStorage.setItem("userId", id);
        } else {
            localStorage.removeItem("userId");
        }
    };

    const logout = () => {
        setToken(null);
        setRoles([]);
        setUserId(null);
        localStorage.removeItem("token");
        localStorage.removeItem("roles");
        localStorage.removeItem("role");
        localStorage.removeItem("userId");
    };

    const hasRole = (role) => roles.includes(role);
    const hasAnyRole = (...allowed) => allowed.some((role) => hasRole(role));
    const primaryRole = roles[0] ?? null;

    return (
        <AuthContext.Provider value={{ token, role: primaryRole, roles, userId, hasRole, hasAnyRole, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

